import { useTranslation } from 'react-i18next';
import { Button, Modal, Text } from '@shared/widgets';

interface IDeleteThreadModalProps {
  open: boolean;
  close: () => void;
  deleteThread: () => void;
}

export const DeleteThreadModal = (props: IDeleteThreadModalProps) => {
  const { t } = useTranslation('messageCenter');

  return (
    <Modal isOpen={props.open} onClose={props.close} title={t('thread.modal.title')}>
      <Text className='mb-6 text-center'>{t('thread.modal.description')}</Text>
      <div className='flex gap-2'>
        <Button color='outlined' fullWidth onClick={props.close}>
          {t('buttons.close', { ns: 'common' })}
        </Button>
        <Button color='primary' fullWidth onClick={props.deleteThread}>
          {t('thread.modal.buttons.delete')}
        </Button>
      </div>
    </Modal>
  );
};
